import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { icons } from '../svg-icons';
import { Icon } from '../interfaces/icon';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  icons = icons;

  constructor(private iconReg: MatIconRegistry, private sanitizer: DomSanitizer) { }

  registerIcons(): void {
    this.icons.forEach((icon: Icon) => this.addIconToRegistry(icon));
  }

  addIconToRegistry({ key, path }: Icon): void {
    const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(path);
    this.iconReg.addSvgIcon(key, safeUrl);
  }
}
